import { FC, useEffect, useRef, useState } from "react";
import styles from "./know-how.module.scss";
import SectionTitle from "../../componsnts/common/sectionTitle/sectionTitle";
import Xarrow from "react-xarrows";
import Breadcrumbs from "../../componsnts/common/breadcrumbs/breadcrumbs";
import ScrollToTop from "../../componsnts/common/scroll-to-top/scroll-to-top";
import useRWD from "../../componsnts/hooks/useRWD";
import { DeviceType } from "../../componsnts/hooks/useRWD";

const KnowHow: FC = () => {
  const device = useRWD();

  const refs = {
    icon1: useRef(null),
    icon2: useRef(null),
    icon3: useRef(null),
    icon4: useRef(null),
    icon5: useRef(null),
    icon6: useRef(null),
    icon2Text: useRef(null),
    icon3Text: useRef(null),
    solutionStart: useRef(null),
    solutionEnd: useRef(null),
  };

  const mobileArrowsConfig = [
    {
      start: refs.icon1,
      startAnchor: "middle",
      end: refs.icon3,
      endAnchor: "middle",
      path: "straight",
      dashness: { strokeLen: 5, nonStrokeLen: 8 },
      curveness: 0,
    },
    {
      start: refs.icon2,
      startAnchor: "bottom",
      end: refs.icon1,
      endAnchor: "top",
      path: "grid",
      dashness: true,
      curveness: 2,
    },
    {
      start: refs.icon2Text,
      startAnchor: "bottom",
      end: refs.icon4,
      endAnchor: "top",
      path: "grid",
      dashness: { strokeLen: 8, nonStrokeLen: 8 },
      showHead: false,
      curveness: 0,
    },
    {
      start: refs.icon3Text,
      startAnchor: "bottom",
      end: refs.icon4,
      endAnchor: "top",
      path: "straight",
      dashness: { strokeLen: 5, nonStrokeLen: 8 },
      showHead: false,
      curveness: 0,
    },
    {
      start: refs.icon4,
      startAnchor: "middle",
      end: refs.icon5,
      endAnchor: "middle",
      path: "straight",
      dashness: true,
      curveness: 2,
    },
    {
      start: refs.icon5,
      startAnchor: "middle",
      end: refs.icon6,
      endAnchor: "middle",
      path: "straight",
      dashness: true,
      curveness: 2,
    },
    {
      start: refs.solutionStart,
      startAnchor: "middle",
      end: refs.solutionEnd,
      endAnchor: "middle",
      path: "straight",
      dashness: true,
      curveness: 2,
    },
  ];

  const arrowsConfig = [
    { start: refs.icon1, end: refs.icon2 },
    { start: refs.icon1, end: refs.icon3 },
    { start: refs.icon2, end: refs.icon4 },
    { start: refs.icon3, end: refs.icon4 },
    { start: refs.icon4, end: refs.icon5 },
    { start: refs.icon5, end: refs.icon6 },
    { start: refs.solutionStart, end: refs.solutionEnd },
  ];

  return (
    <div className={styles["knowHow_container"]}>
      <div className="container">
      </div>
      <SectionTitle
        title="如何購電"
        subTitle="PURCHASE"
        subTitleColor="rgba(149, 157, 165, 0.15)"
        breadcrumbs={true}
      />
      <div className="banner">
        <img
          className="blue_bg"
          src="/assets/images/home/know-how/blue-bg.png"
          alt="background"
        />
        <div className="text_box">
          <p className="banner_content">RENEWABLE</p>
          <p className="banner_content">ENERGY TRADING</p>
          <p className="banner_content chinese">大創電力平台購電模式</p>
          <div className="tag_text">綠電交易平台</div>
        </div>
      </div>

      <div className="section1">
        <SectionTitle
          title="自由商場模式"
          titleColor="#273240"
          subTitle="FREE MARKET"
          subTitleColor="rgba(255, 255, 255, 0.70)"
          backgroundColor="#E8E8E8"
          breadcrumbs={false}
        />
        <div className="flow_container container">
          <div className="flow_box">
            <div className="flow_icons_box step1">
              <div className="stpe1_container">
                <img
                  ref={refs.icon1}
                  className="icons"
                  src="/assets/images/home/know-how/freeMarket/step1.png"
                  alt="icons"
                />
                <div className="flow_text">註冊會員帳號</div>
              </div>
              {device === DeviceType.PC && (
                <div className="step1_alternative_text">二擇一</div>
              )}
            </div>
            <div className="flow_icons_box step2_container">
              <div className="step2_box">
                <img
                  ref={refs.icon2}
                  className="icons"
                  src="/assets/images/home/know-how/freeMarket/step2-up.png"
                  alt="icons"
                />
                <div ref={refs.icon2Text} className="flow_text">
                  直接進入商場選購電力
                </div>
              </div>
              {device !== DeviceType.PC && (
                <div className="step2_alternative_text">二擇一</div>
              )}
              <div className="step2_box">
                <img
                  ref={refs.icon3}
                  className="icons"
                  src="/assets/images/home/know-how/freeMarket/step2-down.png"
                  alt="icons"
                />
                <div ref={refs.icon3Text} className="flow_text">
                  填寫預購信息並刊登預購資訊後等待媒合
                </div>
                
              </div>
            </div>
            <div className="flow_icons_box">
              <img
                ref={refs.icon4}
                className="icons"
                src="/assets/images/home/know-how/freeMarket/step3.png"
                alt="icons"
              />
              <div className="flow_text">申請預購電力</div>
            </div>
            <div className="flow_icons_box">
              <img
                ref={refs.icon5}
                className="icons"
                src="/assets/images/home/know-how/freeMarket/step4.png"
                alt="icons"
              />
              <div className="flow_text unique">填寫預購資訊(保證用電量等等)</div>
            </div>
            <div className="flow_icons_box">
              <img
                ref={refs.icon6}
                className="icons"
                src="/assets/images/home/know-how/freeMarket/step5.png"
                alt="icons"
              />
              <div className="flow_text">
                賣家同意後即可完成媒合，進入簽約階段
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section2">
        <SectionTitle
          title="大創解決方案"
          titleColor="#fff"
          subTitle="SOLUTION"
          subTitleColor="rgba(180, 240, 333, 0.15)"
          backgroundColor="#0095D9"
          breadcrumbs={false}
        />
        <div className="solution_container container">
          <div className="solution_icon_box">
            <img
              ref={refs.solutionStart}
              className="icons"
              src="/assets/images/home/know-how/solution/step1.png"
              alt="icons"
            />
            <div className="solution_text">註冊會員帳號</div>
          </div>
          <div className="solution_icon_box">
            <img
              className="icons"
              src="/assets/images/home/know-how/solution/step2.png"
              alt="icons"
            />
            <div className="solution_text">
              用電大戶或配電需求者直接填寫解決方案表單
            </div>
          </div>
          <div className="solution_icon_box">
            <img
              className="icons"
              src="/assets/images/home/know-how/solution/step3.png"
              alt="icons"
            />
            <div className="solution_text">專人連線協助擬定購電計畫</div>
          </div>
          <div className="solution_icon_box">
            <img
              className="icons"
              src="/assets/images/home/know-how/solution/step4.png"
              alt="icons"
            />
            <div className="solution_text">決定預購價格後由大創協尋賣方</div>
          </div>
          <div className="solution_icon_box">
            <img
              className="icons"
              src="/assets/images/home/know-how/solution/step5.png"
              alt="icons"
            />
            <div className="solution_text">
              賣家價格同意；買方同意轉供計畫內容
            </div>
          </div>
          <div className="solution_icon_box">
            <img
              ref={refs.solutionEnd}
              className="icons"
              src="/assets/images/home/know-how/solution/step6.png"
              alt="icons"
            />
            <div className="solution_text">完成媒合，進入簽約階段</div>
          </div>
        </div>
      </div>

      {device === DeviceType.PC && (
        <>
          {arrowsConfig.map((arrow, index) => (
            <Xarrow
              key={index}
              start={arrow.start}
              startAnchor="middle"
              end={arrow.end}
              endAnchor="middle"
              path="straight"
              dashness={true}
              color="#D1D1D1"
            />
          ))}
        </>
      )}

      {device !== DeviceType.PC && (
        <>
          {mobileArrowsConfig.map((arrow, index) => (
            <Xarrow
              key={index}
              start={arrow.start}
              startAnchor={arrow.startAnchor === "middle" ? "middle" : "bottom"}
              end={arrow.end}
              endAnchor={arrow.endAnchor === "middle" ? "middle" : "top"}
              path={arrow.path === "straight" ? "straight" : "grid"}
              dashness={arrow.dashness}
              color="#D1D1D1"
              curveness={arrow.curveness}
              showHead={arrow.showHead !== undefined ? arrow.showHead : true}
            />
          ))}
        </>
      )}

      <ScrollToTop></ScrollToTop>
    </div>
  );
};
export default KnowHow;
